import Vue from 'vue'
// TODO: import Vuetify from 'vuetify/lib/framework'
import Vuetify from 'vuetify/lib'
import de from 'vuetify/src/locale/de'
import icons from '@/assets/icons'
import theme from '@/assets/theme'

import '@/assets/styles/app.scss'

Vue.use(Vuetify)

export default new Vuetify({
  icons,
  theme: theme,
  lang: {
    locales: { de },
    current: 'de',
  },
})
